import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=459f8029&scoped=true&"
import script from "./ViewProducts.vue?vue&type=script&lang=ts&"
export * from "./ViewProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProducts.vue?vue&type=style&index=0&id=459f8029&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f8029",
  null
  
)

export default component.exports